import React from "react";
import Header from "../components/manage4me/Header";
import HeroSection from "../components/manage4me/HeroSection";
import ProductsSection from "../components/manage4me/ProductsSection";
import CommitmentSection from "../components/manage4me/CommitmentSection";
import ContactSection from "../components/manage4me/ContactSection";
import Footer from "../components/manage4me/Footer";

const Home = () => {
    return (
        <div className="min-h-screen bg-white">
            <Header />
            <HeroSection />
            <ProductsSection />
            <CommitmentSection />
            <ContactSection />
            <Footer />
        </div>
    );
};

export default Home;